import Icon from '../components/Icon.vue'

Icon.register({
  'chess-knight': {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M352 224v224h-320v-46.6c0-30.3 17.1-58 44.2-71.6l57.2-28.6c14.6-7.3 26.5-26.6 26.5-42.9v0-50.3l-22.1 11.1c-5.5 2.7-11.1 9.7-12.5 15.6l-11.8 47.3c-0.8 3.3-4 7-7.2 8.2l-29.6 11.8c-1.2 0.5-3.2 0.9-4.5 0.9-1.4 0-3.6-0.5-4.9-1l-60.2-26.8c-3.9-1.7-7.1-6.7-7.1-11v0-158.3c0-6.4 2.5-12.5 7-17l9-9-14.2-28.4c-1-2-1.8-5.4-1.8-7.6v0c0-6.6 5.4-12 12-12h148c106 0 192 86 192 192zM372 464c6.6 0 12 5.4 12 12v24c0 6.6-5.4 12-12 12h-360c-6.6 0-12-5.4-12-12v-24c0-6.6 5.4-12 12-12h360zM52 128c-11 0-20 9-20 20s9 20 20 20 20-9 20-20-9-20-20-20z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/chess-knight.js
// module id = null
// module chunks = 